module.exports = __webpack_public_path__ + "static/media/Group 1534.823726bd.svg";